import React, { useState, useEffect, useContext, Fragment } from 'react';
import { getProcessoApregoado, getDocumentos, getDownloadDocumento, getSessaoDetalhada } from '../../../services/Service';
import { Card, CardContent, CardActions, Typography, CardHeader, Grid, LinearProgress, Link, SvgIcon } from '@material-ui/core/';
import { Lock, Timer, PictureAsPdf } from '@material-ui/icons';
import { AppContext } from '../../../components/servidor/shared/context';
import './index.css';
import './recurso.css';
import Cronometro from '../../cronometro';
import SustentacaoOral from '../painel/sustentacaoOral';
import { agendarRenovacaoToken, getToken } from '../../../services/AuthService';

require('../../../services/EnvelopeMultiplosCanais');
const { getUrlApi } = require('../../../util/api');

const Processo = (props) => {
    const [processoApregoado, setProcessoApregoado] = useState(props.processoApregoado);
    //const [pedidoSustentacaoOral, setPedidoSustentacaoOral] = useState();
    const [documentos, setDocumentos] = useState(props.documentos);
    const [isLoading, setIsLoading] = useState();

    const [recursos, setRecursos] = useState();
    const [decisoes, setDecisoes] = useState();

    const [isShowHTML, setIsShowHTML] = useState(false);
    const [isShowPDF, setIsShowPDF] = useState(false);
    //const [numPages, setNumPages] = useState();
    //const [pageNumber, setPageNumber] = useState(0);
    const [conteudo, setConteudo] = useState(null);

    const [urlConteudo, setUrlConteudo] = useState(null);
    const [showConteudoPDF, setShowConteudoPDF] = useState(false);
    const [showConteudoHTML, setShowConteudoHTML] = useState(false);
    //const [token, setToken] = useState(getToken());
    const [conteudoHTML, setConteudoHTML] = useState();

    //const [numeroProcessoSemClasse, setNumeroProcessoSemClasse] = useState();

    const context = useContext(AppContext);

    useEffect(() => {
        setProcessoApregoado(null);
        //setPedidoSustentacaoOral(null);

        setConteudo(null);
        setIsShowPDF(false);
        setIsShowHTML(false);
        let numeroProcesso;
        if (context.orgao && context.orgao.sigla && context.sessao && context.sessao.id) {
            getProcessoApregoado(context.orgao.sigla, context.sessao.id).then((resp) => {
                setProcessoApregoado(resp)
                if (resp) {
                    numeroProcesso = defineNumeroProcesso(resp.processoApregoado.numeroProcessoComFase);
                    recuperaListaDocumentos(numeroProcesso, resp.processo.origem, resp.sessaoId).then(docs => {
                        if (docs) {
                            defineListaRecursos(docs);
                            defineListaDecicoes(docs, numeroProcesso, resp.sessaoId);
                        }
                    });
                }
            });
        }
        iniciarEnvelope();
    }, [context.orgao, context.sessao]);

    useEffect(() => {
        agendarRenovacaoToken();
    }, []);

    /*const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
    }*/

    /*const onPageChange = (page) => {
        if (page) {
            setPageNumber(page.selected);
        }
    }*/

    const recuperaProcessoDigitalizado = (docs) => {
        if (!docs) {
            return undefined;
        }

        let lista = docs.filter(documento => {
            if (documento.tipoDocumento.toUpperCase().includes("PROCESSO") && documento.tipoDocumento.toUpperCase().includes("DIGITALIZADO")) {
                return documento;
            }
        });

        if (!lista || !lista[0]) {
            return undefined;
        }

        return lista[0];
    }

    const recuperaListaDocumentos = async (processo, origem, idSessao) => {
        setIsLoading(true);
        setIsShowPDF(false);
        setIsShowHTML(false);

        try {
            const docs = await getDocumentos(processo, idSessao);

            if (origem.toUpperCase() === 'ESIJ') {
                setDocumentos(docs.reverse());
            }

            setDocumentos(docs);
            context.setIsShowPecas(true);
            setIsLoading(false);

            return docs;
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    }

    const iniciarEnvelope = async () => {
        let settings = {
            url: await getUrlApi('REACT_APP_ENVELOPE') + '/cometd'
        };
        if (context.sessao && context.sessao.id) {
            let clienteEnvelopeProcessoApregoado = window.envelope.novoClienteMultiplosCanais(settings);
            clienteEnvelopeProcessoApregoado.iniciar(function () {
                let sessoes = context.sessao.id.split('----');

                for (let s of sessoes) {
                    let canalPregao = `/sessao/${s}/pregao`;
                    if (!clienteEnvelopeProcessoApregoado.canalEstaRegistrado(canalPregao)) {
                        clienteEnvelopeProcessoApregoado.registrarCanal(canalPregao, (mensagem) => {
                            let data = JSON.parse(mensagem.data);
                            if(data.apregoado){
                                console.log('Processo apregoado: ' + data.apregoado[0]);
                                tratarAtualizacaoProcessoApregado(mensagem, setProcessoApregoado, setDocumentos, setConteudo, setIsShowPDF, setIsShowHTML, context, defineNumeroProcesso, defineListaRecursos, defineListaDecicoes);
                            } else {
                                setProcessoApregoado(null); //cancelamento de pregão
                            }
                        });
                    }
                }
            });

            let clienteEnvelopePresencaAdvogado = window.envelope.novoClienteMultiplosCanais(settings);
            clienteEnvelopePresencaAdvogado.iniciar(function () {
                let canalPregao = `/sessao/${context.sessao.id}/processo`;
                if (!clienteEnvelopePresencaAdvogado.canalEstaRegistrado(canalPregao)) {
                    console.log('canalPregao', canalPregao)
                    clienteEnvelopePresencaAdvogado.registrarCanal(canalPregao, (mensagem) => {
                        console.log('envelope', mensagem);
                        verificaExistenciaProcessoCacheSessao(mensagem);
                        //tratarAtualizacaoAdvogados(context, setPedidoSustentacaoOral);
                    });
                };
            });
        }
    }

    async function verificaExistenciaProcessoCacheSessao(mensagem) {
        if(mensagem.data && mensagem.data.includes('processo')) { 
            let numeroProcessoNotificacao = mensagem.data.substring(mensagem.data.indexOf('[')+1,mensagem.data.indexOf(']'));
            let localStorageSessaoCompleta = await localStorage.getItem("sessaoDetalhada");
            let sessaoCompleta = await JSON.parse(localStorageSessaoCompleta);
            let processoEstaNaSessao = sessaoCompleta.processos.find(p => p.processo.numeroCompleto.includes(numeroProcessoNotificacao))
            if(!processoEstaNaSessao) {
                setIsLoading(true);
                await getSessaoDetalhada(context.sessao.id);
                setIsLoading(false);
            }
        }
    }

    function tratarAtualizacaoProcessoApregado(mensagem, setProcessoApregoado, setDocumentos, setConteudo, setIsShowPDF, setIsShowHTML, context, defineNumeroProcesso, defineListaRecursos, defineListaDecicoes) {
        getProcessoApregoado(context.orgao.sigla, context.sessao.id).then((resp) => {

            setProcessoApregoado(null);
            //setPedidoSustentacaoOral(null);
            setDocumentos(null);
            setConteudo(null);
            setIsShowPDF(false);
            setIsShowHTML(false);

            if (resp) {
                setProcessoApregoado(resp);

                if (processoApregoado === resp) {
                    if (resp.pedidoSustentacaoOral) {
                        //setPedidoSustentacaoOral(resp.pedidoSustentacaoOral);
                    }
                }

                let numeroProcesso = defineNumeroProcesso(resp.processoApregoado.numeroProcessoComFase);
                recuperaListaDocumentos(numeroProcesso, resp.processo.origem, resp.sessaoId).then(docs => {
                    if (docs) {
                        defineListaRecursos(docs);
                        defineListaDecicoes(docs, numeroProcesso, resp.sessaoId);
                    }
                });
            }
        });
    }

    /*function tratarAtualizacaoAdvogados(context, setPedidoSustentacaoOral) {
        getProcessoApregoado(context.orgao.sigla, context.sessao.id).then((resp) => {
            setIsLoading(true);
            setProcessoApregoado(resp);
            setPedidoSustentacaoOral(resp.pedidoSustentacaoOral);
            setIsLoading(false);
        });
    }*/

    const defineNumeroProcesso = (numeroProcessoComFase) => {
        if (numeroProcessoComFase) {
            var numero = '' + numeroProcessoComFase.numero;
            numero = numero.padStart(7, '0');
            var vara = '' + numeroProcessoComFase.vara;
            vara = vara.padStart(4, '0');
            var digito = '' + numeroProcessoComFase.digito;
            digito = digito.padStart(2, '0');
            var tribunal = '' + numeroProcessoComFase.tribunal;
            tribunal = tribunal.padStart(2, '0');
            var numProcessoSemClasse = numero + "-" + digito + "." + numeroProcessoComFase.ano + "." + numeroProcessoComFase.justica + "." + tribunal + "." + vara;
            //setNumeroProcessoSemClasse(numProcessoSemClasse);
            return numProcessoSemClasse;
        }
        return null;

    }

    const defineListaRecursos = (docs) => {
        let decisoesERecursos;
        if (docs) {
            decisoesERecursos = JSON.parse('{    "pje":{       "decisao":[          "TST - Decisão/Despacho",          "Decisão",          "Sentença",          "Acórdão",          "Decisão",          "Sentença"       ],       "recurso":[          "Recurso especial",          "Embargos",          "Agravo de Instrumento em Agravo de Petição",          "Contrarrazões",          "Embargos",          "Embargos à Execução",          "Agravo",          "Agravo de Instrumento em Recurso de Revista",          "Agravo de Instrumento em Recurso Extraordinário",          "Agravo de Instrumento em Recurso Ordinário",          "Agravo de Instrumento em Recurso Ordinário para o STF",          "Agravo de Petição",          "Agravo Regimental",          "Embargos de Declaração",          "Embargos Infringentes",          "Embargos Infringentes na Execução Fiscal",          "Recurso Adesivo",          "Recurso de Revista",          "Recurso Extraordinário",          "Recurso Ordinário"       ]    },    "esij":{       "decisao":[          "TST - Decisão/Despacho",          "1ª INSTÂNCIA - Sentença da RT",          "2ª INSTÂNCIA - Decisão do RO",          "2ª INSTÂNCIA - Decisão do AG",          "2ª INSTÂNCIA - Despacho de Admissibilidade do RR",          "Sentença",          "TST - Decisão do AIRR",          "TST - Decisão do RR",          "TST - Decisão do RO",          "TST - Decisão dos EDs",          "TST - Decisão do AG",          "TST - Decisão do Agravo",          "TST - Decisão de Embargos",          "TST - Despacho de Admissibilidade do RE com Certidão de Publicação",          "TST - Despacho de Admissibilidade do RE (SEM Certidão de Publicação)",          "STF - Decisão do AISTF",          "STF - Decisão do AG",          "STF - Decisão dos EDs",          "STF - Decisão do Recurso Extraordinário",          "STF - Decisão em Recursos Diversos",          "CSJT - Acórdão",          "TST - Acórdão",          "Sentença",          "Acórdão"       ],       "recurso":[          "1ª INSTÂNCIA - Sentença da RT",          "2ª INSTÂNCIA - Agravo Regimental",          "TST - Recurso de Revista pelo(a) Reclamante",          "TST - Recurso de Revista pelo(a) Reclamado(a)",          "TST - Recurso de Revista Adesivo",          "TST - Agravo de Instrumento em Recurso de Revista pelo(a) Reclamad",          "TST - Recurso de Revista ou Agravo de Instrumento de Terceiro",          "TST - Recurso Ordinário",          "Recurso de Revista",          "TST - Agravo",          "TST - Embargos",          "STF - Recurso Extraordinário",          "STF - EDs no STF",          "TST - Agravo de Instrumento em Recurso de Revista pelo(a) Reclamante",          "Embargos Declaratórios",          "CSJT - Recurso",          "Embargos",          "Embargos de Declaração",          "Embargos à Execução",          "Agravo",          "Agravo Regimental",          "Agravo de Instrumento em Recurso de Revista",          "Agravo",          "Agravo Regimental",          "Agravo de Instrumento em Agravo de Petição",          "Agravo de Instrumento em Recurso Extraordinário",          "Agravo de Instrumento em Recurso Ordinário",          "Agravo de Instrumento em Recurso Ordinário para o STF",          "Agravo de Instrumento em Recurso de Revista",          "Agravo de Petição",          "Recurso Adesivo",          "Recurso Extraordinário",          "Recurso Ordinário",          "Recurso de Revista",          "Recurso especial",          "Recurso inominado",          "Contrarrazões ao RR",          "Contrarazões ao Recurso Adesivo",          "Contraminuta ao AIRR",          "Contrarrazões ao RO",          "2ª INSTÂNCIA - Contrarrazões ao RO"       ]    } }');
        }
        
        let recursosArray = [].concat(decisoesERecursos.esij.recurso, decisoesERecursos.pje.recurso);

        let lista = docs.filter(e => {
            for (let recurso of recursosArray) {
                let peca = e.tipoDocumento.substring(e.tipoDocumento.indexOf('-') + 1);

                if (peca.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase() == recurso.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) return true;
            }
        });
        setRecursos(lista);
    };

    const defineListaDecicoes = (docs) => {
        let decisoesERecursos;
        if (docs) {
            decisoesERecursos = JSON.parse('{    "pje":{       "decisao":[          "Decisão/Despacho",          "Decisão",          "Sentença",          "Acórdão",          "Decisão",          "Sentença"       ],       "recurso":[          "Recurso especial",          "Embargos",          "Agravo de Instrumento em Agravo de Petição",          "Contrarrazões",          "Embargos",          "Embargos à Execução",          "Agravo",          "Agravo de Instrumento em Recurso de Revista",          "Agravo de Instrumento em Recurso Extraordinário",          "Agravo de Instrumento em Recurso Ordinário",          "Agravo de Instrumento em Recurso Ordinário para o STF",          "Agravo de Petição",          "Agravo Regimental",          "Embargos de Declaração",          "Embargos Infringentes",          "Embargos Infringentes na Execução Fiscal",          "Recurso Adesivo",          "Recurso de Revista",          "Recurso Extraordinário",          "Recurso Ordinário"       ]    },    "esij":{       "decisao":[          "TST - Decisão/Despacho",          "1ª INSTÂNCIA - Sentença da RT",          "2ª INSTÂNCIA - Decisão do RO",          "2ª INSTÂNCIA - Decisão do AG",          "2ª INSTÂNCIA - Despacho de Admissibilidade do RR",          "Sentença",          "TST - Decisão do AIRR",          "TST - Decisão do RR",          "TST - Decisão do RO",          "TST - Decisão dos EDs",          "TST - Decisão do AG",          "TST - Decisão do Agravo",          "TST - Decisão de Embargos",          "TST - Despacho de Admissibilidade do RE com Certidão de Publicação",          "TST - Despacho de Admissibilidade do RE (SEM Certidão de Publicação)",          "STF - Decisão do AISTF",          "STF - Decisão do AG",          "STF - Decisão dos EDs",          "STF - Decisão do Recurso Extraordinário",          "STF - Decisão em Recursos Diversos",          "CSJT - Acórdão",          "TST - Acórdão",          "Sentença",          "Acórdão"       ],       "recurso":[          "1ª INSTÂNCIA - Sentença da RT",          "2ª INSTÂNCIA - Agravo Regimental",          "TST - Recurso de Revista pelo(a) Reclamante",          "TST - Recurso de Revista pelo(a) Reclamado(a)",          "TST - Recurso de Revista Adesivo",          "TST - Agravo de Instrumento em Recurso de Revista pelo(a) Reclamad",          "TST - Recurso de Revista ou Agravo de Instrumento de Terceiro",          "TST - Recurso Ordinário",          "Recurso de Revista",          "TST - Agravo",          "TST - Embargos",          "STF - Recurso Extraordinário",          "STF - EDs no STF",          "TST - Agravo de Instrumento em Recurso de Revista pelo(a) Reclamante",          "Embargos Declaratórios",          "CSJT - Recurso",          "Embargos",          "Embargos de Declaração",          "Embargos à Execução",          "Agravo",          "Agravo Regimental",          "Agravo de Instrumento em Recurso de Revista",          "Agravo",          "Agravo Regimental",          "Agravo de Instrumento em Agravo de Petição",          "Agravo de Instrumento em Recurso Extraordinário",          "Agravo de Instrumento em Recurso Ordinário",          "Agravo de Instrumento em Recurso Ordinário para o STF",          "Agravo de Instrumento em Recurso de Revista",          "Agravo de Petição",          "Recurso Adesivo",          "Recurso Extraordinário",          "Recurso Ordinário",          "Recurso de Revista",          "Recurso especial",          "Recurso inominado",          "Contrarrazões ao RR",          "Contrarazões ao Recurso Adesivo",          "Contraminuta ao AIRR",          "Contrarrazões ao RO",          "2ª INSTÂNCIA - Contrarrazões ao RO"       ]    } }');
        }

        let decisoesArray = [].concat(decisoesERecursos.esij.decisao, decisoesERecursos.pje.decisao);

        let lista = docs.filter(e => {
            for (let decisao of decisoesArray) {
                let peca = e.tipoDocumento.substring(e.tipoDocumento.indexOf('-') + 1);

                if (peca.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase() == decisao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()) return true;
            }
        });

        setDecisoes(lista);
        setConteudo(null);
        setIsShowPDF(false);
        setIsShowHTML(false);
        setUrlConteudo(null);
        setConteudoHTML();
        setShowConteudoPDF(false);
        setShowConteudoHTML(false);
        context.defineShowHome(true);
    };

    const downloadDocumento = async (documento, event, numeroProcesso, sessaoId) => {
        if (event) {
            event.preventDefault();
        }

        let nr;
        let sessao;

        if (processoApregoado.processo.numeroCompleto && processoApregoado.sessaoId) {
            nr = processoApregoado.processo.numeroCompleto;
            sessao = processoApregoado.sessaoId;
        } else {
            nr = numeroProcesso;
            sessao = sessaoId;
        }

        if (documento.tipoArquivo === 'PDF') {
            baixarDocumentoPDF(nr, sessao, documento.id, documento.tipoArquivo, documento.tipoDocumento);
            setShowConteudoPDF(false);
            setShowConteudoHTML(false);
            context.defineShowHome(true);
        } else {
            setIsLoading(true)
            try {
                let html = await getDownloadDocumento(nr, sessao, documento.id, documento.tipoArquivo);
                setConteudoHTML(html);
                setShowConteudoPDF(false);
                setShowConteudoHTML(true);
                context.defineShowHome(false);
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
                console.error(error);
            }
        }
    }

    const getUrlConteudo = async (processoId, sessaoId, documentoId, tipoArquivo) => {
        var urlApi = await getUrlApi('REACT_APP_SESSAO');
        return urlApi + `/documentos/${sessaoId}/${processoId}/${documentoId}/${tipoArquivo}/conteudo`;
    };

    const b64DecodeUnicode = (str) => {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    /*const formataData = (data) => {
        if (data == null) {
            return '';
        }
        let dia = data.substring(8, 10);
        let mes = data.substring(5, 7);
        let ano = data.substring(0, 4);
        return dia + "/" + mes + "/" + ano;
    }*/

    function readTextFile(file, callback) {
        var rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        }
        rawFile.send(null);
    }

    async function baixarDocumentoPDF(nr, sessao, id, tipoArquivo, tipoDocumento) {
        if (tipoArquivo !== "PDF") {
            throw new Error("Não é um arquivo PDF.");
        }

        let mimeType = 'application/pdf';
        let conteudoPDF = await getDownloadDocumento(nr, sessao, id, tipoArquivo);

        let link = document.createElement('a');
        document.body.appendChild(link);
        link.download = tipoDocumento + '.pdf';
        link.href = URL.createObjectURL(new Blob([conteudoPDF], { type: mimeType }));
        link.click();
        document.body.removeChild(link);
    }

    /**
     * @todo Remover esse ícone quando a bilioteca de ícones do Ícones Material for atualizada para a versão 5.x
     * @param {Array} properties 
     * @returns {SvgIcon}
     */
     function HtmlIconMuiv5(properties) {
        return (
            <SvgIcon {...properties}>
                <path d="M3.5 9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9zm14 0H13c-.55 0-1 .45-1 1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5c0-.55-.45-1-1-1zM11 9H6v1.5h1.75V15h1.5v-4.5H11V9zm13 6v-1.5h-2.5V9H20v6h4z" />
            </SvgIcon>
        );
    }

    function exibirIconeArquivo(item) {
        if (item === undefined || item.tipoArquivo === undefined) {
            return '';
        }

        if (item.tipoArquivo === 'PDF') {
            return (<>&nbsp;&nbsp;<PictureAsPdf/></>);
        } else if (item.tipoArquivo === 'HTML') {
            //return (<>&nbsp;&nbsp;<Html/></>); // TODO Atualizar biblioteca de ícones para adicionar o ícone HTML do Material UI v5
            return (<>&nbsp;&nbsp;<HtmlIconMuiv5/></>);
        } else {
            return '';
        }
    }

    function exibirTamanhoArquivo(item) {
        if (item === undefined || item.tamanhoArquivo === undefined || (typeof item.tamanhoArquivo === 'number' && item.tamanhoArquivo === 0)) {
            return '';
        }

        let tamanhoFormatado = formatarTamanhoArquivo(item.tamanhoArquivo);
        if (tamanhoFormatado) {
            return ` [${tamanhoFormatado}]`;
        }

        return '';
    }

    /*function formatarTamanhoEstimadoInteiroTeor(processoSessao) {
        let tamanhoEstimado = processoSessao.processo.detalhes.documentos
            .reduce((acumulador, documentoAtual) => acumulador += documentoAtual.tamanhoArquivo || 0, 0);

        return tamanhoEstimado > 0 ? '[≈ ' + formatarTamanhoArquivo(tamanhoEstimado) + ']' : '';
    }*/

    function formatarTamanhoArquivo(tamanho) {
        let KBYTES_EM_BYTES = 1024;
        let MEGABYTES_EM_BYTES = KBYTES_EM_BYTES * KBYTES_EM_BYTES;

        let tamanhoComUnidadeDeMedida = '';
        if (tamanho < KBYTES_EM_BYTES) {
            tamanhoComUnidadeDeMedida += tamanho + ' Bytes';
        } else if (tamanho > MEGABYTES_EM_BYTES) {
            tamanhoComUnidadeDeMedida += '≈ ' + Math.round(tamanho / MEGABYTES_EM_BYTES) + ' MB';
        } else {
            tamanhoComUnidadeDeMedida += '≈ ' + Math.round(tamanho / KBYTES_EM_BYTES) + ' KB';
        }

        return tamanhoComUnidadeDeMedida;
    }

    function exibirLinkDocumentoDigitalizado(itens) {
        let docDigitalizado = recuperaProcessoDigitalizado(itens);

        if (docDigitalizado !== undefined) {
            return (
                <>
                    <Link href="" onClick={(e) => downloadDocumento(docDigitalizado, e)}>
                        <Typography><u>Processo digitalizado</u>{exibirIconeArquivo(docDigitalizado)}{exibirTamanhoArquivo(docDigitalizado)}</Typography>
                    </Link>
                </>
            );
        }

        return '';
    }

    return (
        <div>
            {(processoApregoado != null && processoApregoado.sessaoId != null) ?
                <Grid container spacing={2}>
                    <Grid item xs={5}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Card >
                                    <CardContent>
                                        <Typography variant={"h6"}><b>PROCESSO APREGOADO: </b></Typography>
                                        <Typography variant={"h6"} style={processoApregoado &&
                                            processoApregoado.processo &&
                                            processoApregoado.processo.segredoJustica ? { color: "red" } : { color: "black" }}>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{processoApregoado &&
                                                processoApregoado.processo &&
                                                processoApregoado.processo.numeroCompleto} </b>
                                            <span >
                                                {processoApregoado &&
                                                    processoApregoado.processo &&
                                                    processoApregoado.processo.segredoJustica ? <Lock style={{ color: "red" }} /> : ''}
                                            </span>
                                        </Typography>
                                        {processoApregoado &&
                                            processoApregoado.processo &&
                                            processoApregoado.processo.relator.sigla && <div>
                                                <Typography style={{ fontSize: 20 }}  >Relator: </Typography>
                                                <Typography style={{ color: "black" }} >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {processoApregoado &&
                                                    processoApregoado.processo &&
                                                    processoApregoado.processo.relator.nome}</Typography>
                                            </div>}
                                        {processoApregoado &&
                                            processoApregoado.processo.vistor &&
                                            <Typography variant={"h6"}><b>VISTOR: </b>{processoApregoado &&
                                                processoApregoado.processo.vistor &&
                                                processoApregoado.processo.vistor.sigla}
                                            </Typography>}

                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12}>
                                <Card >
                                    <CardHeader titleTypographyProps={{ variant: 'h6' }} title={<div style={{ display: "flex" }}>PREFERÊNCIA E SUSTENTAÇÃO ORAL<div style={{ marginLeft: 10, display: "flex" }}><Timer /><Cronometro /></div></div>} />
                                    <CardContent style={{ overflowY: "auto", height: 80 }}>
                                        {processoApregoado.pedidoSustentacaoOral != null && processoApregoado.pedidoSustentacaoOral.pedidosDetalhados != null
                                            ? <SustentacaoOral indexPrincipal={-1} pedidosDetalhados={processoApregoado.pedidoSustentacaoOral.pedidosDetalhados} />
                                            : <Typography>Nenhum pedido de preferência ou sustentação oral.</Typography>}
                                    </CardContent>
                                    <CardActions>

                                    </CardActions>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card >
                                    <CardHeader titleTypographyProps={{ variant: 'h6' }} title="DECISÕES" />
                                    {(decisoes && Array.isArray(decisoes) && decisoes.length > 0) ?
                                        <CardContent style={{ overflowY: "auto", height: 80 }}>
                                            {decisoes.map((descisao, index) => (
                                                <div key={index}>
                                                    <Grid className="grid" onClick={() => { downloadDocumento(descisao) }} style={{display: 'flow-root'}}>
                                                        <Typography display="inline" className="circle">D</Typography><span></span><Typography style={{ marginLeft: 5, fontsize: 14, fontWeight: "bold" }} display="inline">{descisao.tipoDocumento.trim().toUpperCase()}</Typography><Typography style={{ marginLeft: 5, float: "right" }} display="inline">{descisao.data.dia}/{descisao.data.mes}/{descisao.data.ano}</Typography>
                                                    </Grid>
                                                </div>))}
                                        </CardContent>
                                    :
                                        <CardContent style={{ overflowY: "auto", height: 80 }}>
                                            {exibirLinkDocumentoDigitalizado(documentos)}
                                        </CardContent>
                                    }
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card >
                                    <CardHeader titleTypographyProps={{ variant: 'h6' }} title="RECURSOS" />
                                    {(recursos && Array.isArray(recursos) && recursos.length > 0) ?
                                        <CardContent style={{ overflowY: "auto", height: 80 }}>
                                            {recursos.map((recurso, index) => (
                                                <div key={index}>
                                                    <Grid className="grid" onClick={() => { downloadDocumento(recurso) }} style={{display: 'flow-root'}}>
                                                        <Typography display="inline" className="circle">R</Typography><span></span><Typography style={{ marginLeft: 5, fontSize: 14, fontWeight: "bold" }} display="inline">{recurso.tipoDocumento.trim().toUpperCase()}</Typography><Typography style={{ marginLeft: 5, float: "right" }} display="inline">{recurso.data.dia}/{recurso.data.mes}/{recurso.data.ano}</Typography>
                                                    </Grid>
                                                </div>))}
                                        </CardContent>
                                    :
                                        <CardContent style={{ overflowY: "auto", height: 80 }}>
                                            {exibirLinkDocumentoDigitalizado(documentos)}
                                        </CardContent>
                                    }
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    <Grid item xs={7} >
                        {isLoading && <LinearProgress />}
                        {!isShowPDF && !isShowHTML && <Card style={{ overflowY: "auto", height: 773 }} >
                            <CardHeader title={context.isShowPecas ? 'Peças' : ''}
                                action={
                                    <div>
                                        <Typography aria-label="TODAS AS PEÇAS" variant="h6" style={{ cursor: "pointer", marginRight: 30 }} onClick={() => { !context.showHome ? context.defineShowHome(true) : recuperaListaDocumentos(processoApregoado.processo.numeroCompleto, processoApregoado.processo.origem, processoApregoado.sessaoId, context) }}>
                                            {!context.showHome ? 'X' : 'TODAS AS PEÇAS'}
                                        </Typography>
                                    </div>
                                }
                            />
                            <CardContent>
                                {context.isShowPecas &&

                                    <span>
                                        {isLoading && <LinearProgress />}
                                        {context.showHome && documentos && documentos.length > 0 && documentos.map((item, index) => (
                                            <Link data-testid="download" href="" key={index} onClick={(e) => downloadDocumento(item, e)} >
                                                <Typography id={"idDocumento" + item.id} style={item.tipoDocumento.includes('Decisão') || item.tipoDocumento.includes('Recurso') ? { fontWeight: "bold" } : {}}>
                                                    {item.tipoDocumento} ({item.data.dia}/{item.data.mes}/{item.data.ano}){exibirIconeArquivo(item)}{exibirTamanhoArquivo(item)}
                                                </Typography>
                                            </Link>
                                        ))}

                                        {!context.showHome && <Grid container style={{ color: "white" }}>
                                            <Fragment/>
                                        </Grid>}

                                        {showConteudoPDF && urlConteudo && !context.showHome &&
                                            <div style={{ alignContent: "center", overflowY: "auto", minHeight: 773 }}>
                                            </div>
                                        }
                                        {showConteudoHTML && !context.showHome &&
                                            <div dangerouslySetInnerHTML={{ __html: conteudoHTML }} ></div>
                                        }
                                    </span>

                                }
                            </CardContent>
                        </Card>}


                        {isShowPDF &&

                            <div>
                                <Card style={{ overflowY: "auto", height: 773 }} >
                                    <CardHeader title={conteudo.nome}
                                        action={
                                            <div>
                                                <Typography aria-label="TODAS AS PEÇAS" variant="h6" style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => { recuperaListaDocumentos(processoApregoado.processo.numeroCompleto, processoApregoado.processo.origem, processoApregoado.sessaoId, context) }}>
                                                    TODAS AS PEÇAS
                                                </Typography>
                                            </div>
                                        }
                                    />
                                    <CardContent>
                                        {isShowPDF && conteudo && conteudo.conteudo && <div style={{ alignContent: "center", overflow: "auto" }}>
                                        </div>}
                                    </CardContent>
                                </Card>
                            </div>}

                        {isShowHTML && conteudo.conteudo && <Card style={{ overflowY: "auto", height: 773 }} >
                            <CardHeader title={conteudo.nome}
                                action={
                                    <div>
                                        <Typography aria-label="TODAS AS PEÇAS" variant="h6" style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => { recuperaListaDocumentos(processoApregoado.processo.numeroCompleto, processoApregoado.processo.origem, processoApregoado.idSessao, context) }}>
                                            TODAS AS PEÇAS
                                        </Typography>
                                    </div>
                                }
                            />
                            <CardContent>
                                <div dangerouslySetInnerHTML={{ __html: b64DecodeUnicode(conteudo.conteudo) }} ></div>

                            </CardContent>
                        </Card>}
                    </Grid>
                </Grid >
                :

                <Grid container >
                    <Grid item xs={4} />
                    <Grid item xs={4} style={{ padding: 10 }}>
                        <Card style={{ height: 190 }}>
                            <CardContent>
                                <Typography variant="h6">Não existe nenhum processo apregoado para essa sessão no momento.</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={4} />
                </Grid>

            }

        </div >
    )
}

export default Processo;

